<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card" style="padding: 29px">
      <div class="se-title-section">
        <h4>دستگاه‌های فعال</h4>
        <div class="se-icon">
          <img src="@/assets/icons/verified.svg" />
        </div>
      </div>
      <table class="setting-table">
        <tr v-for="device in activeDeviceList" :key="device.id">
          <td
            style="font-size: 13px; color: red"
            @click="deleteSession(device)"
          >
            منقضی کردن
          </td>
          <td>
            <h5>
              {{ device.type }}
            </h5>
            <p>{{ device.os }} {{ device.os_version }}</p>
            <p style="font-size: 10px">
              {{ device.last_online }}
            </p>
          </td>
          <td>
            <img src="@/assets/icons/smartphone.svg" />
          </td>
        </tr>
      </table>

      <div class="se-title-section">
        <h4>دستگاه‌های خارج شده</h4>
        <div class="se-icon">
          <img src="@/assets/icons/verified.svg" />
        </div>
      </div>
      <table class="setting-table">
        <tr v-for="device in deActiveDeviceList" :key="device.id">
          <td
            style="font-size: 13px; color: red"
            @click="deleteSession(device)"
          >
            منقضی کردن
          </td>
          <td>
            <h5>
              {{ device.type }}
            </h5>
            <p>{{ device.os }} {{ device.os_version }}</p>
            <p style="font-size: 10px">
              {{ device.last_online }}
            </p>
          </td>
          <td>
            <img src="@/assets/icons/smartphone.svg" />
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  beforeMount() {
    this.getDeviceList();
  },
  data() {
    return {
      activeDeviceList: [],
      deActiveDeviceList: [],
    };
  },
  methods: {
    getDeviceList() {
      this.$store.dispatch("settings/getDeviceList").then((respons) => {
        for (let index = 0; index < respons.length; index++) {
          if (respons[index].is_active) {
            this.activeDeviceList.push(respons[index]);
          } else {
            this.deActiveDeviceList.push(respons[index]);
          }
        }
      });
    },
    deleteSession(device) {
      console.log(device);
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped></style>
